<template>
  <v-container>
    <v-row dense>
      <v-col v-for="(item, i) in items" :key="i" cols="6">
        <v-card>
          <v-img
            :src="item.icon"
            gradient="to bottom, rgba(0,0,0,0), rgba(0,0,0,.1)"
            class="white--text align-end"
          >
            <v-card-title v-text="item.name"></v-card-title>
          </v-img>
          <v-card-actions>
            <v-btn icon>
              <v-icon>mdi-heart</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn color="orange" outlined to="/case/list">
              进入
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          id: 1,
          name: "我的APP",
          icon: "https://images.oonnnoo.com/favicons/lidong.me"
        }
        // {
        //   id: 2,
        //   name: "我的APP",
        //   icon: "https://images.oonnnoo.com/favicons/lidong.me"
        // },
        // {
        //   id: 3,
        //   name: "我的APP",
        //   icon: "https://images.oonnnoo.com/favicons/lidong.me"
        // },
        // {
        //   id: 4,
        //   name: "我的APP",
        //   icon: "https://images.oonnnoo.com/favicons/lidong.me"
        // }
      ]
    };
  }
};
</script>
